const LOGIN_PATH = `/_hcms/mem/login`;
const LOGIN_VERIFY_PATH = `/_hcms/customerportal/v1/login-verify`;
const LOGOUT_PATH = '/_hcms/mem/logout';
const FORM_DATA_PATH = `/_hcms/customerportal/v1/layout/form-version`;
const PORTAL_DATA_PATH = `/_hcms/customerportal/v1/portal-data`;
const TICKET_BASE_PATH = `/_hcms/customerportal/v1/ticket`;
const TICKET_CLOSE_BASE_PATH = `${TICKET_BASE_PATH}/close`;
const TICKET_EXPORT_CSV_PATH = `${TICKET_BASE_PATH}/export/csv`;
const TICKET_LISTINGS_PATH = `${TICKET_BASE_PATH}/search`;
const TICKET_THREAD_VIEW_BASE_PATH = `/_hcms/customerportal/v1/threadview`;
const PUBLISH_MESSAGE_BASE_PATH = `/_hcms/customerportal/v1/publish`;
const FILE_UPLOAD_URL_PATH = `/_hcms/customerportal/v1/attachment/upload-url`;
const FILE_MANAGER_BASE_PATH = `/_hcms/customerportal/filemanager`;
const TICKET_RELEVANT_THREADS_BASE_PATH = `/_hcms/customerportal/v1/threadview/relevant-threads`;
const THREAD_ATTACHMENTS_BASE_PATH = `/_hcms/customerportal/v1/attachment/thread`;
export { LOGIN_PATH, LOGIN_VERIFY_PATH, LOGOUT_PATH, FORM_DATA_PATH, PORTAL_DATA_PATH, TICKET_BASE_PATH, TICKET_CLOSE_BASE_PATH, TICKET_EXPORT_CSV_PATH, TICKET_LISTINGS_PATH, TICKET_THREAD_VIEW_BASE_PATH, TICKET_RELEVANT_THREADS_BASE_PATH, THREAD_ATTACHMENTS_BASE_PATH, PUBLISH_MESSAGE_BASE_PATH, FILE_UPLOAD_URL_PATH, FILE_MANAGER_BASE_PATH };